import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Plus } from 'lucide-react';

import { cn } from '@/lib/utils';

interface AppShellProps {
  children: React.ReactNode;
}

export default function AppShell({ children }: AppShellProps) {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="border-b bg-card">
        <div className="max-w-screen-2xl mx-auto flex items-center justify-between h-14 px-4">
          <Link to="/" className="flex items-center gap-3 font-semibold text-foreground">
            <img src="/wbd-logo.png" alt="Warner Bros. Discovery" className="h-7" />
            <span className="border-l pl-3 border-border">AI Forensics</span>
            <span className="text-xs font-normal text-orange-600 bg-orange-50 px-1.5 py-0.5 rounded">Non-Production PoC</span>
          </Link>

          <nav className="flex items-center gap-4">
            <Link
              to="/"
              className={cn(
                'flex items-center gap-1.5 text-sm transition-colors',
                pathname === '/' ? 'text-foreground font-medium' : 'text-muted-foreground hover:text-foreground',
              )}
            >
              <LayoutDashboard className="h-4 w-4" />
              Dashboard
            </Link>
            <Link
              to="/upload"
              className={cn(
                'flex items-center gap-1.5 text-sm transition-colors',
                pathname === '/upload' ? 'text-foreground font-medium' : 'text-muted-foreground hover:text-foreground',
              )}
            >
              <Plus className="h-4 w-4" />
              New Analysis
            </Link>
            <span className="text-xs text-muted-foreground bg-muted px-2 py-1 rounded">v0.1.0</span>
          </nav>
        </div>
      </header>

      <main className="flex-1">{children}</main>
    </div>
  );
}
